export enum EKeyboardConstants {
    ENTER = 'Enter',
    ARROW_DOWN = 'ArrowDown',
    ARROW_UP = 'ArrowUp',
}
